import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {Observable} from "rxjs/Rx";
import 'rxjs/add/operator/map'
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {BatchPaymentClientsModel} from "./batch-payments.model";


@Injectable()
export class BatchPaymentsService {

    private API_ROOT:string = '/batch-payments';

    constructor(private http:Http) {
    }

    getList(filter?):Observable<ListResponseModel<BatchPaymentClientsModel>> {

        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(this.API_ROOT, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());

    }

    getOne(debtId):Observable<ResponseModel<BatchPaymentClientsModel>> {

        return this.http
            .get(`/debts/${debtId}/batch-payments`)
            .map(r => r.json());
    }

    getPendingTransactions(debtId, accountId):Observable<ListResponseModel<any>> {

        return this.http
            .get(`/debts/${debtId}/accounts/${accountId}/pending-transactions`)
            .map(r => r.json());
    }

    changeFundedDebtStatus(client_id: any, status_id: any): any
    {
        return this.http
            .put(this.API_ROOT + '/change-funded-debt-status', {client_id: client_id, status_id: status_id})
            .map(r => r.json());
    }


}


// WEBPACK FOOTER //
// ./src/app/models/batch-payments/batch-payments.service.ts